export default "__VITE_ASSET__zSKY56ai__"